'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_PushNotificationData(title, body, tag) {
  this.Lapp_data_PushNotificationData__f_title = null;
  this.Lapp_data_PushNotificationData__f_body = null;
  this.Lapp_data_PushNotificationData__f_tag = null;
  this.Lapp_data_PushNotificationData__f_title = title;
  this.Lapp_data_PushNotificationData__f_body = body;
  this.Lapp_data_PushNotificationData__f_tag = tag;
}
export { $c_Lapp_data_PushNotificationData as $c_Lapp_data_PushNotificationData };
$c_Lapp_data_PushNotificationData.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_PushNotificationData.prototype.constructor = $c_Lapp_data_PushNotificationData;
/** @constructor */
function $h_Lapp_data_PushNotificationData() {
}
export { $h_Lapp_data_PushNotificationData as $h_Lapp_data_PushNotificationData };
$h_Lapp_data_PushNotificationData.prototype = $c_Lapp_data_PushNotificationData.prototype;
$c_Lapp_data_PushNotificationData.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_PushNotificationData.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-316270307), true);
});
$c_Lapp_data_PushNotificationData.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_PushNotificationData)) {
    if ((this.Lapp_data_PushNotificationData__f_title === x$0.Lapp_data_PushNotificationData__f_title)) {
      var x = this.Lapp_data_PushNotificationData__f_body;
      var x$2 = x$0.Lapp_data_PushNotificationData__f_body;
      var $x_1 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Lapp_data_PushNotificationData__f_tag;
      var x$4 = x$0.Lapp_data_PushNotificationData__f_tag;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_data_PushNotificationData.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_PushNotificationData.prototype.productArity__I = (function() {
  return 3;
});
$c_Lapp_data_PushNotificationData.prototype.productPrefix__T = (function() {
  return "PushNotificationData";
});
$c_Lapp_data_PushNotificationData.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lapp_data_PushNotificationData__f_title;
      break;
    }
    case 1: {
      return this.Lapp_data_PushNotificationData__f_body;
      break;
    }
    case 2: {
      return this.Lapp_data_PushNotificationData__f_tag;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lapp_data_PushNotificationData.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "title";
      break;
    }
    case 1: {
      return "body";
      break;
    }
    case 2: {
      return "tag";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_data_PushNotificationData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_PushNotificationData)));
}
export { $isArrayOf_Lapp_data_PushNotificationData as $isArrayOf_Lapp_data_PushNotificationData };
var $d_Lapp_data_PushNotificationData = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_PushNotificationData, "app.data.PushNotificationData", ({
  Lapp_data_PushNotificationData: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_data_PushNotificationData as $d_Lapp_data_PushNotificationData };
//# sourceMappingURL=app.data.-Push-Notification-Data.js.map
